import { render, staticRenderFns } from "./TreeLeaf.vue?vue&type=template&id=38e9a4a8"
import script from "./TreeLeaf.vue?vue&type=script&lang=js"
export * from "./TreeLeaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports